export default __webpack_public_path__ + "81a40947ff84d9362b1ced32d22c141f.glb";